import { useEffect, useState } from "react"
import { api } from "../../../../env"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import TrackMeta from "./TrackMeta"
import CreateTrackChapters from "./CreateTrackChapters"

export default function CreateTrack() {

    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const isManagerContext = location.pathname.startsWith('/manager')

    useEffect(() => {
        if (id) api.get(`tracks/${id}`)
            .then(res => setTrack(res.data))
            .catch(err => navigate('..'))
    }, [id])

    const [track, setTrack] = useState(undefined)

    const handleTrackCreate = (it) => {
        if (isManagerContext) {
            navigate(`../edit/${it.id}`)
        } else {
            navigate(`../${it.id}`)
        }
        setTrack(prev => {
            return {
                ...prev,
                ...it
            }
        })
    }
    const updateTrack = (it) => setTrack(it)

    return(<div className="standard-padding page-xl-centered showing">
        <TrackMeta track={track} onChange={handleTrackCreate}/>
        <div className="v-spacer-xl"/>
        <CreateTrackChapters track={track} onTrackUpdate={updateTrack}/>
    </div>)
}